import { Actions } from '../enums/ActionEnums';
import { InvoiceStatus } from '../enums/InvoiceStatusEnums';
import { IAddress, ICompany, IContact, IInvoice } from '../generated/graphql';
import { ActionType } from '../models/appContext';
import { InvoiceType } from '../models/invoice';
import { INVOICE_STATUS_CONFIRMED } from '../utils/constants';

export const invoiceReducer = (
  state: InvoiceType | null,
  action: ActionType
): InvoiceType | null => {
  switch (action.type) {
    case Actions.SetInvoice:
      const { invoice, productInfo } = action.payload;
      return {
        id: invoice?.id,
        company: invoice
          ? ({
              name: invoice.details.company_name as string,
              main_address: { complete_vat_number: invoice.details.company_address_vat }
            } as ICompany)
          : null,
        contact: invoice
          ? ({
              fullName: invoice.details.fullName as string,
              email: action.payload.invoice?.details.contact_email
            } as IContact)
          : null,
        address: invoice ? ({ name: invoice?.details.address_name as string } as IAddress) : null,
        status: setInvoiceStatus(action.payload.invoice),
        // email: action.payload.invoice?.details.contact_email,
        errors: {},
        invoice_full: invoice,
        productInfo: productInfo ?? null,
        paymentDetails: invoice?.paymentDetails,
        isPaymentDetailsInEditMode: false,
        notes: invoice?.notes ?? null,
        membership: invoice?.membership ?? null,
        po_nr: invoice?.po_nr ?? null,
        remarks: invoice?.remarks ?? null
      };
    case Actions.SetInvoiceClientDetails:
      return {
        ...(state as InvoiceType),
        ...action.payload
      };
    case Actions.SetInvoiceProductInfo:
      return {
        ...(state as InvoiceType),
        productInfo: { ...action.payload }
      };
    case Actions.SetInvoiceErrors:
      return {
        ...(state as InvoiceType),
        errors: { ...action.payload }
      };
    case Actions.ResetInvoiceErrors:
      return {
        ...(state as InvoiceType),
        errors: {}
      };
    case Actions.SetInvoicePaymentDetails:
      return {
        ...(state as InvoiceType),
        paymentDetails: { ...action.payload }
      };
    case Actions.SetInvoicePaymentDetailsMode:
      return {
        ...(state as InvoiceType),
        isPaymentDetailsInEditMode: action.payload
      };
    case Actions.ResetInvoice:
      return null;
    case Actions.ResetInvoiceProductInfo: {
      return {
        ...(state as InvoiceType),
        productInfo: null
      };
    }
    case Actions.SetInvoiceNotes: {
      return {
        ...(state as InvoiceType),
        notes: action.payload.text
      };
    }
    case Actions.SetInvoicePoNumber: {
      return {
        ...(state as InvoiceType),
        po_nr: action.payload.text
      };
    }
    case Actions.SetMembershipStartDate: {
      return {
        ...(state as InvoiceType),
        remarks: action.payload.text
      };
    }
    default:
      return state;
  }
};

const setInvoiceStatus = (invoice: IInvoice | null): InvoiceStatus => {
  if (invoice) {
    if (invoice.is_credit) {
      return invoice.status.name === INVOICE_STATUS_CONFIRMED
        ? InvoiceStatus.ConfirmedCredit
        : InvoiceStatus.PendingCredit;
    } else {
      return invoice.status.name === INVOICE_STATUS_CONFIRMED
        ? InvoiceStatus.Confirmed
        : InvoiceStatus.Pending;
    }
  }

  return InvoiceStatus.New;
};
